import { PagedDataSource } from '@mango/core';
import { of } from 'rxjs';

/**
 * Restores a guard that Mango 4.20 had and Mango 22 lost: a table whose columns the current role may not read has
 * no properties to fetch, and must simply stay empty. Without it, getData() logs "No properties specified for
 * get-query", returns undefined, and update() then fails with "Cannot read properties of undefined (reading 'pipe')",
 * which opens Mango's error page (for example the alerts screen when the role may not read alerts).
 *
 * Mango 4.20 behaviour (PagedDataSource.getProperties): no fetch properties -> an empty result.
 * Remove this file once Mango 22 has the guard again.
 */
const proto = PagedDataSource.prototype as any;
const originalGetData = proto.getData;

proto.getData = function (this: any, ...args: any[]) {
    if (this.fetchProperties == null || this.fetchProperties.length < 1) {
        this.getData$.next(); // cancels a previous request, as the original does
        this.setData([]);
        this.setItems([]);
        this.length = 0;
        return of(this.data);
    }

    // Properties are set but the role may read none of them: Mango logs "No properties specified for get-query",
    // catches it and returns undefined, and update() then fails on undefined.pipe(). Treat it as an empty result too.
    const result = originalGetData.apply(this, args);
    if (result == null) {
        this.setData([]);
        this.setItems([]);
        this.length = 0;
        return of(this.data);
    }

    return result;
};
